module.exports = "<header class=\"bordered\">\n  <a onclick=\"window.history.back()\" class=\"back\"><span class=\"icon blue x-small left\"></span> Back</a>\n  <h6 class=\"grow\">Which security system would you like to trigger this programming?</h6>\n  <button class=\"default clickable\" (click)=\"goHome()\">Cancel</button>\n</header>\n\n<prg-select-device [source]=\"devices | async\" (selected)=\"systemSelected($event)\"></prg-select-device>\n"


//////////////////
// WEBPACK FOOTER
// ./~/@c4/programming/src/app/quickstarts/quickstart-security-system/select-system/select-system.component.html
// module id = 1598
// module chunks = 2